import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@core/components/ui/button";
import { Link } from "react-router-dom";
import { Footer } from "@core/components/shared/Footer";
import { SEOHead } from "../components/SEOHead";

// color-exempt-file — retokenisation Phase 6 ui-themes : dark:bg-[#0a0a0a] preserve le rendu dark historique (voir memoire ui-themes) ; blobs decoratifs purple/blue-500/10 laisses en l'etat (ambiance, non lies au theme)

export default function Contact() {
  const { t } = useTranslation(["polls", "common", "errors"]);

  return (
    <div className="min-h-screen-safe bg-background dark:bg-[#0a0a0a] text-foreground relative overflow-hidden flex flex-col">
      <SEOHead
        title={t("polls:contact_seo_title")}
        description={t("polls:contact_seo_description")}
      />
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-purple-500/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-blue-500/10 rounded-full blur-[120px]" />
      </div>

      {/* Header/Nav Space */}
      <header className="relative z-10 border-b border-border backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center">
                <span className="font-bold text-white">D</span>
              </div>
              <span className="text-xl font-bold text-foreground">
                DooDates
              </span>
            </Link>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-32 text-center relative z-10 flex-1">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-muted border border-border mb-6">
          <span className="text-sm text-primary font-medium">
            {t("polls:contact_badge")}
          </span>
        </div>
        <h1 className="text-5xl md:text-6xl font-bold mb-8 tracking-tight">
          {t("polls:contact_title_lead")}{" "}
          <span className="text-primary">
            {t("polls:contact_title_highlight")}
          </span>
        </h1>
        <p className="text-xl text-muted-foreground mb-12 max-w-2xl mx-auto leading-relaxed">
          {t("polls:contact_intro")}
        </p>

        <div className="bg-card border border-border rounded-2xl p-8 max-w-xl mx-auto backdrop-blur-sm mb-12">
          <p className="text-2xl font-bold text-foreground mb-2">
            support@doodates.com
          </p>
          <p className="text-muted-foreground text-sm">
            {t("polls:contact_response_time")}
          </p>
        </div>

        <div className="flex justify-center gap-4">
          <Link to="/">
            <Button
              variant="outline"
              className="border-border hover:bg-accent text-foreground"
              data-testid="contact-back-home"
            >
              {t("common:back_home")}
            </Button>
          </Link>
        </div>
      </div>

      <div className="relative z-10">
        <Footer />
      </div>
    </div>
  );
}
